import { ExperienceEnum } from '@app/_api/enums/experience.enum';
import { TreeNodeDimensions } from '@app/pages/home/tree/tree-canvas/utils/tree-node-dimensions';
import { UISkill } from '@app/pages/home/tree/tree-canvas/tree-types';
import { TreeColor, TreeColors } from '@app/pages/home/tree/tree-canvas/utils/tree-colors';

export class TreeCanvasUtil extends TreeNodeDimensions {
  public static readonly UNASSIGNED_SKILLS_STROKE_COLOR = 'unassigned';

  public static readonly colors = TreeColors;

  public static readonly fillColor: Record<TreeColor, string> = {
    green: 'fill-[#18981D]/50 dark:fill-[#91E697]/60',
    red: 'fill-[#E12D39]/50 dark:fill-[#FF9B9B]/60',
    yellow: 'fill-[#F0B429]/50 dark:fill-[#FCE588]/60',
    cyan: 'fill-[#1CD4D4]/50 dark:fill-[#92FDF2]/60',
    orange: 'fill-[#ff6600]/50 dark:fill-[#ff6600]/60',
    darkblue: 'fill-[#0055ff]/50 dark:fill-[#4f89ff]/60',
    purple: 'fill-[#8719E0]/50 dark:fill-[#DAC4FF]/60',
    pink: 'fill-[#fd00e6]/50 dark:fill-[#fd00e6]/60',
    beige: 'fill-[#4d300f]/50 dark:fill-[#FFFDD0]/60',
    brown: 'fill-[#A52A2A] dark:fill-[#D2B48C]',
    navy: 'fill-[#000080] dark:fill-[#4682B4]',
    unassigned: 'fill-none dark:fill-none',
  } as const;

  public static readonly strokeColor: Record<TreeColor, string> = {
    green: 'stroke-[#18981D] dark:stroke-[#91E697]',
    red: 'stroke-[#FF0000] dark:stroke-[#FF6666]',
    yellow: 'stroke-[#FFA500] dark:stroke-[#FFD580]',
    cyan: 'stroke-[#00FFFF] dark:stroke-[#80FFFF]',
    orange: 'stroke-[#ff6600] dark:stroke-[#ff6600]',
    darkblue: 'stroke-[#0055ff] dark:stroke-[#4f89ff]',
    purple: 'stroke-[#800080] dark:stroke-[#D580D5]',
    pink: 'stroke-[#fd00e6] dark:stroke-[#fd00e6]',
    brown: 'stroke-[#A52A2A] dark:stroke-[#D2B48C]',
    beige: 'stroke-[#4d300f] dark:stroke-[#FFFDD0]',
    navy: 'stroke-[#000080] dark:stroke-[#4682B4]',
    unassigned: 'stroke-[#999] dark:stroke-[#999]',
  } as const;

  public static hideExperienceLevel(skillNode: UISkill) {
    return !skillNode.experienceLevel || skillNode.experienceLevel === ExperienceEnum.NONE;
  }
}
